import React, { useState, useEffect, useRef, ChangeEventHandler, InputHTMLAttributes, FormEvent, ChangeEvent } from 'react';

type PrevResponse = {
    sender: any,
    message: string,
    id: any,
}

export const Soket = () => {

    // State to store the input from the user
    const [input, setInput] = useState<string>('');
    // State to store the responses/messages
    const [responses, setResponses] = useState<PrevResponse[]>([]);
    // Ref to manage the WebSocket connection
    const ws = useRef<WebSocket>(new WebSocket('ws://127.0.0.1:8000/api/ws/chat/'));
    // Ref to scroll to the latest message
    const messagesEndRef = useRef<HTMLDivElement>(null);
    // Maximum number of attempts to reconnect
    const [reconnectAttempts, setReconnectAttempts] = useState(0);
    const maxReconnectAttempts = 5;

    ws.current = new WebSocket('ws://127.0.0.1:8000/api/ws/chat/');
    let ongoingStream: any = null; // To track the ongoing stream's ID

    ws.current.onopen = () => {
        console.log("WebSocket connected!");
        setReconnectAttempts(0); // Reset reconnect attempts on successful connection
    };

    ws.current.onmessage = (event) => {
        const data = JSON.parse(event.data);
        let sender = data.name;

        // Handle different types of events from the WebSocket
        if (data.event === 'on_parser_start') {
            // When a new stream starts
            ongoingStream = { id: data.run_id, content: '' };
            setResponses(prevResponses => [...prevResponses, { sender, message: '', id: data.run_id }]);
        } else if (data.event === 'on_parser_stream' && ongoingStream && data.run_id === ongoingStream.id) {
            // During a stream, appending new chunks of data
            setResponses(prevResponses => prevResponses.map(msg =>
                msg.id === data.run_id ? { ...msg, message: msg.message + data.data.chunk } : msg));
        }
    };

    ws.current.onerror = (event) => {
        console.error("WebSocket error observed:", event);
    };

    ws.current.onclose = (event) => {
        console.log(`WebSocket is closed now. Code: ${event.code}, Reason: ${event.reason}`);
        handleReconnect();
    };

// Function to handle reconnection attempts with exponential backoff
const handleReconnect = () => {
    if (reconnectAttempts < maxReconnectAttempts) {
        let timeout = Math.pow(2, reconnectAttempts) * 1000; // Exponential backoff
        setTimeout(() => {
            Soket(); // Attempt to reconnect
        }, timeout);
    } else {
        console.log("Max reconnect attempts reached, not attempting further reconnects.");
    }
};

// Effect hook to setup and cleanup the WebSocket connection
useEffect(() => {
    Soket(); // Setup WebSocket on component mount

    return () => {
        if (ws.current.readyState === WebSocket.OPEN) {
            ws.current.close(); // Close WebSocket on component unmount
        }
    };
}, []);

// Effect hook to auto-scroll to the latest message
useEffect(() => {
    //messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
}, [responses]);

// Function to render each message
const renderMessage = (response: PrevResponse, index: number) => (
    <div key={index} className={`message ${response.sender}`}>
        <strong>{response.sender}</strong> <p>{response.message}</p>
    </div>
);

// Handler for input changes
function handleInputChange (e: ChangeEvent<HTMLInputElement>) {
    setInput(e.currentTarget.value);
};

// Handler for form submission
function handleSubmit (event: FormEvent<HTMLFormElement>) {
    //e.
    const userMessage: PrevResponse = { sender: "You", message: input, id: 0 };
    setResponses(prevResponses => [...prevResponses, userMessage]);
    ws.current.send(JSON.stringify({ message: input })); // Send message through WebSocket
    setInput(''); // Clear input field
};

return (
    <div className="chat-container">
        <div className="messages-container">
            {responses.map((response, index) => renderMessage(response, index))}
            <div ref={messagesEndRef} /> {/* Invisible element to help scroll into view */}
        </div>
        <form onSubmit={(e) => {handleSubmit(e)}} className="input-form">
            <input
                type="text"
                value={input}
                onChange={(e) => {handleInputChange(e)}}
                placeholder="Type your message here..."
            />
            <button type="submit">Send</button>
        </form>
    </div>
)
}